import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';

import {
  fail,
  getReservedProfileId,
  setReservedProfileId,
  updateReservedProfileId,
  updateReservedProfileIdSuccess,
} from '@/Slices/ReservedProfileIdSlice';

import { getReservedProfileIdAPI, putReservedProfileIdAPI } from '@/Axios/api/reservedProfileId';

function* handleGetReservedProfileId() {
  try {
    const data: AxiosResponse = yield call(getReservedProfileIdAPI);
    yield put(setReservedProfileId(data.data));
  } catch (e) {
    console.log(e);
    yield put(fail(e));
  }
}

function* handlePutReservedProfileId(action: PayloadAction<string[]>) {
  try {
    yield call(putReservedProfileIdAPI, action.payload);
    yield put(updateReservedProfileIdSuccess({}));
    message.success({
      content: 'Saved successfully.',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  } catch (e) {
    yield put(fail(e));
    message.error({
      content: 'Saved failed. Please try again.',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  }
}

export function* watchGetReservedProfileId() {
  yield takeEvery(getReservedProfileId.type, handleGetReservedProfileId);
}
export function* watchPutReservedProfileId() {
  yield takeEvery(updateReservedProfileId.type, handlePutReservedProfileId);
}
